import gql from 'graphql-tag';

const productInfoFragment = gql`
  fragment ProductInfo on Product {
    id
    name
    price
    imagesUrls
    stars
    isFavorite
    reviews {
      stars
      text
    }
  }
`;

const MAIN_PAGE_QUERY = gql`
  query Products($category: String) {
    products(category: $category) {
      ...ProductInfo
    }
    seenProducts {
      id
      name
      imagesUrls
      price
      isFavorite
    }
    bakers {
      id
      firstName
      lastName
      username
      image
      stars
    }
  }

  ${productInfoFragment}
`;

const GET_BAKERS = gql`
  {
    bakers {
      id
      firstName
      lastName
      username
      image
      stars
    }
  }
`;

const GET_BAKER = gql`
  query user($username: String) {
    user(username: $username) {
      image
      firstName
      stars
      bio
    }
  }
`;

const GET_GREETING_INFO = gql`
  {
    me {
      image
      firstName
    }
  }
`;

const GET_USER = gql`
  {
    me {
      image
      firstName
      lastName
      username
      bio
      stars
    }
  }
`;

const GET_PRODUCTS = gql`
  query Products($category: String) {
    products(category: $category) {
      ...ProductInfo
      categories {
        label
        value
      }
    }
  }
  ${productInfoFragment}
`;

const GET_PRODUCTS_BY_CATEGORY = gql`
  query Products($category: String, $prodsPerPage: Int, $offset: Int) {
    productsByCategory(
      category: $category
      prodsPerPage: $prodsPerPage
      offset: $offset
    ) {
      id
      name
      price
      imagesUrls
      stars
      reviews {
        stars
        text
      }
      categories {
        label
        value
      }
    }
    productsCount(category: $category)
  }
`;

const GET_PRODUCTS_BY_BAKER = gql`
  query ProductsByBaker($bakerId: String!) {
    productsByBaker(bakerId: $bakerId) {
      ...ProductInfo
    }
  }
  ${productInfoFragment}
`;

const SEARCH_PRODUCTS = gql`
  query Products($searchStr: String) {
    productsSearch(value: $searchStr) {
      id
      name
    }
  }
`;

const GET_PRODUCT = gql`
  query Product($id: String!) {
    product(id: $id) {
      ...ProductInfo
      user {
        id
        image
        firstName
        lastName
        username
        stars
      }
      description
      active
      categories {
        value
        label
      }
      own
    }
  }
  ${productInfoFragment}
`;

const GET_MY_PRODUCTS = gql`
  {
    myProducts {
      ...ProductInfo
      categories {
        label
        value
      }
    }
  }
  ${productInfoFragment}
`;

const GET_CATEGORIES = gql`
  {
    categories {
      label
      value
    }
  }
`;

const GET_CHATS = gql`
  {
    userChats {
      id
      from
      product {
        id
        name
        image
      }
      lastMessage {
        id
        author {
          id
          firstName
          lastName
          image
        }
        text
        createdAt
      }
      unread
    }
  }
`;

const GET_CHAT = gql`
  query Chat($id: String!) {
    chat(id: $id) {
      me
      product {
        id
        name
        image
      }
      messages {
        id
        author {
          id
          firstName
          lastName
          image
        }
        text
        createdAt
      }
    }
  }
`;

const FIND_CHAT = gql`
  query FindChat($productId: String!) {
    findChat(productId: $productId)
  }
`;

const GET_SEEN_PRODUCTS = gql`
  {
    seenProducts {
      id
      name
      imagesUrls
      price
      isFavorite
    }
  }
`;

const GET_FAVORITES_PRODUCTS = gql`
  {
    favoriteProducts {
      id
      name
      imagesUrls
      price
      isFavorite
    }
  }
`;

export {
  GET_PRODUCTS,
  GET_PRODUCTS_BY_BAKER,
  GET_PRODUCTS_BY_CATEGORY,
  SEARCH_PRODUCTS,
  GET_PRODUCT,
  GET_BAKER,
  GET_BAKERS,
  GET_USER,
  GET_MY_PRODUCTS,
  GET_CATEGORIES,
  GET_GREETING_INFO,
  GET_CHATS,
  GET_CHAT,
  FIND_CHAT,
  GET_SEEN_PRODUCTS,
  MAIN_PAGE_QUERY,
  GET_FAVORITES_PRODUCTS,
  productInfoFragment
};
